import { LinkPresentationProps } from "@insite/mobius/Link";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design.surya";
import { css } from "styled-components";

/**
 * Shared look for the Configure / Edit links on MGBW configurator lines (cart, project details).
 * The color and size go through Mobius props because Link renders its text in an inner Typography
 * whose own theme rules outrank anything set on the anchor.
 */
export const mgbwConfiguratorLinkStyles: LinkPresentationProps = {
    color: COLORS.primary.base,
    typographyProps: { size: TYPOGRAPHY.size.smaller },
    hoverStyle: { textDecoration: "underline" },
    css: css`
        align-self: flex-start;
        text-decoration: none;
    `,
};
